var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_4417)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10.3583 7.38244C9.38562 7.787 7.44169 8.62433 4.52649 9.89444C4.05311 10.0827 3.80513 10.2668 3.78255 10.4469C3.7444 10.7512 4.12551 10.8711 4.64447 11.0343C4.71507 11.0565 4.78821 11.0795 4.86319 11.1038C5.37378 11.2698 6.0606 11.464 6.41765 11.4717C6.74153 11.4787 7.10302 11.3452 7.50211 11.0711C10.2259 9.2325 11.6319 8.30318 11.7202 8.28314C11.7824 8.26901 11.8687 8.25124 11.9272 8.30321C11.9857 8.35518 11.9799 8.4536 11.9737 8.48C11.936 8.64095 10.44 10.0318 9.66584 10.7515C9.4245 10.9759 9.25331 11.135 9.21831 11.1714C9.13992 11.2528 9.06002 11.3298 8.98323 11.4038C8.50889 11.8611 8.15317 12.204 9.00292 12.764C9.41128 13.0331 9.73804 13.2556 10.064 13.4776C10.4201 13.7201 10.7752 13.9619 11.2346 14.2631C11.3516 14.3398 11.4634 14.4195 11.5723 14.4971C11.9866 14.7925 12.3589 15.0578 12.8187 15.0155C13.086 14.9909 13.362 14.7397 13.5021 13.9903C13.8334 12.2193 14.4846 8.38205 14.6351 6.80081C14.6483 6.66228 14.6317 6.48498 14.6184 6.40715C14.6051 6.32932 14.5772 6.21842 14.4761 6.13633C14.3562 6.03911 14.1713 6.01861 14.0886 6.02007C13.7124 6.0267 13.1354 6.22735 10.3583 7.38244Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_4417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.9640231409a2809b591a7bc77f5cbfae.svg";
export { ForwardRef as ReactComponent };